<div class="progress-bar">
  <svg
    class="progress-status"
    viewBox="0 0 100 10"
    preserveAspectRatio="none"
    aria-hidden="true"
  >
    <rect
      [attr.width]="normalizedProgress"
      height="10"
      [ngClass]="{
        'in-progress': status === uploadStatus.IN_PROGRESS,
        completed: status === uploadStatus.SUCCESS,
        fail: status === uploadStatus.FAILED,
      }"
    ></rect>
  </svg>
</div>
